import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { PrevButton, NextButton, usePrevNextButtons } from '../atoms/EmblaCarouselArrowButtons';
const PartSelectCarousel = ({ currentBundle, selectedPart, prodIndex, setSelectedPart }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'center', skipSnaps: true });
    const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);
    return (React.createElement("div", { className: "fg-cust--step__colour-select--component-buttons" },
        React.createElement(PrevButton, { onClick: onPrevButtonClick, disabled: prevBtnDisabled }),
        React.createElement("div", { className: "embla" },
            React.createElement("div", { ref: emblaRef, className: "embla__viewport is-draggable" },
                React.createElement("div", { className: "embla__container" }, Object.keys(currentBundle).map((key) => {
                    return currentBundle[key].map((product, productIndex) => {
                        if (product.otherVariants.length > 1) {
                            return (React.createElement("button", { className: `variant-button embla__slide ${product.part == selectedPart ? 'selected' : ''}`, key: `colour-step--${productIndex}`, onClick: () => setSelectedPart(product.part, prodIndex) }, product.title));
                        }
                    });
                })))),
        React.createElement(NextButton, { onClick: onNextButtonClick, disabled: nextBtnDisabled })));
};
export default PartSelectCarousel;
